import React, { HTMLProps } from 'react';

export const TooltipIndicator: React.FC<{} & HTMLProps<HTMLDivElement>> = ({ className, children, ...rest }) => {
    return (
        <div
            className={`w-6 h-6 rounded-full bg-bnd-green inline-flex justify-center items-center ${className}`}
            {...rest}
        >
            <div className="inline-block text-center mt-0.5 text-bnd-white-1 dark:text-bnd-black-1">{children}</div>
        </div>
    );
};
